import * as React from 'react';
import { BodyMediumRegular } from 'smoothie';

interface AccountVerificationLetterLinkProps {
    onPress: () => void;
    children?: React.ReactNode;
}

export const AccountVerificationLetterLink = ({
    onPress,
    children = 'Download account verification letter',
}: AccountVerificationLetterLinkProps) => {
    return (
        <BodyMediumRegular
            textDecorationLine="underline"
            color="$green1100"
            onPress={onPress}
            hoverStyle={{ cursor: 'pointer' }}
        >
            {children}
        </BodyMediumRegular>
    );
};
